"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calcAssetValueOwned; // @flow

function calcAssetValueOwned(asset) {
  var hasLease = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // If lease, no value

  if (hasLease) return 0;
  var value = Number(asset.value || 0); // Calculate from valueOwned or portionOwned if present

  if (asset.portionOwned != null) {
    value *= Number(asset.portionOwned || 100) / 100;
  } else if (asset.valueOwned != null) {
    value = Number(asset.valueOwned);
  }

  return value;
}